let helpers = require('./helpers');

const utils = (storeUtils = window.flex) => {

    const { getStore } = storeUtils;

    function claim(key, claims) {
        const store = getStore();
        if (!key || !store || !store.appContext || !store.appContext.claims) {
            return false;
        }
        claims = claims || store.appContext.claims.toJS();

        if (_.indexOf(claims, key) > -1) {
            return true;
        }

        const claimWithValue = _.find(claims, (claim) => {
            return claim ? helpers.startsWith(claim, key + "=") : false;
        });
        const returnStringValue = claimWithValue ? claimWithValue.slice(claimWithValue.lastIndexOf("=") + 1) : false;

        if (returnStringValue && returnStringValue.toLowerCase() === "true"){
            return true;
        }
        else if (returnStringValue && returnStringValue.toLowerCase() === "false"){
            return false;
        }

        return returnStringValue;
    }

    return {
        claim
    };
}

module.exports = utils;